export default __webpack_public_path__ + "static/media/mauern-2.ca67ca82.jpeg";